import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from './slice';

const selectDomain = (state: RootState) => state.userDialog || initialState;

export const selectUserDialog = createSelector(
  [selectDomain],
  userDialogState => userDialogState,
);
